import { render, staticRenderFns } from "./menuProduction.vue?vue&type=template&id=3694a87c&scoped=true&"
import script from "./menuProduction.vue?vue&type=script&lang=js&"
export * from "./menuProduction.vue?vue&type=script&lang=js&"
import style0 from "./menuProduction.vue?vue&type=style&index=0&id=3694a87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3694a87c",
  null
  
)

export default component.exports